import { useQuery } from '@tanstack/react-query'
import { api } from '../utils/api'
import type { OverLimitStatus } from '../components/banners/overLimitMessage'

/** Is this store over its plan limits? Null until known, and on any failure: never a reason to block anything. */
export function useOverLimit(enabled = true): OverLimitStatus | null {
  const { data } = useQuery<OverLimitStatus | null>({
    queryKey: ['subscription', 'over-limit'],
    enabled,
    staleTime: 60_000,
    retry: false,
    queryFn: async () => (await api.get('/subscription/over-limit')).data?.data ?? null,
  })
  return data ?? null
}
